import Image from 'next/image';
import { cn } from '@virginexperiencedays/tailwind';

import type { HTMLAttributes } from 'react';

type Props = {
  iconSrc: string;
} & HTMLAttributes<HTMLDivElement>;

export const VirginLovesCard = ({ iconSrc, className, ...props }: Props) => {
  return (
    <div className={cn('flex flex-nowrap items-center gap-2', className)} {...props}>
      <div>
        <Image src={iconSrc} alt="Icon" width={42} height={42} />
      </div>
      <div className="flex flex-1 flex-col gap-1 pt-1 leading-none">
        <p className="text-neutral-strong text-lg font-bold font-semibold leading-7">
          Virgin Loves
        </p>
        <p className="text-neutral text-sm leading-5">We love this, we think you will too</p>
      </div>
    </div>
  );
};
